import React from "react";
import { IconProps } from "./IconProps";

const MinusCircleIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6923 10C13.6923 10.1632 13.6275 10.3197 13.5121 10.4351C13.3967 10.5505 13.2401 10.6154 13.0769 10.6154H6.92308C6.75987 10.6154 6.60334 10.5505 6.48793 10.4351C6.37253 10.3197 6.30769 10.1632 6.30769 10C6.30769 9.83679 6.37253 9.68026 6.48793 9.56486C6.60334 9.44945 6.75987 9.38461 6.92308 9.38461H13.0769C13.2401 9.38461 13.3967 9.44945 13.5121 9.56486C13.6275 9.68026 13.6923 9.83679 13.6923 10ZM18 10C18 11.5822 17.5308 13.129 16.6518 14.4446C15.7727 15.7602 14.5233 16.7855 13.0615 17.391C11.5997 17.9965 9.99112 18.155 8.43928 17.8463C6.88743 17.5376 5.46196 16.7757 4.34314 15.6569C3.22433 14.538 2.4624 13.1126 2.15372 11.5607C1.84504 10.0089 2.00346 8.40034 2.60896 6.93853C3.21446 5.47672 4.23984 4.22729 5.55544 3.34824C6.87103 2.46919 8.41775 2 10 2C12.121 2.00224 14.1546 2.84581 15.6544 4.34562C17.1542 5.84542 17.9978 7.87895 18 10ZM16.7692 10C16.7692 8.66117 16.3722 7.35241 15.6284 6.23922C14.8846 5.12602 13.8274 4.25839 12.5905 3.74605C11.3536 3.2337 9.99249 3.09965 8.67939 3.36084C7.36628 3.62203 6.16012 4.26674 5.21343 5.21343C4.26674 6.16012 3.62203 7.36629 3.36084 8.67939C3.09965 9.99249 3.2337 11.3536 3.74605 12.5905C4.25839 13.8274 5.12602 14.8846 6.23922 15.6284C7.35241 16.3722 8.66117 16.7692 10 16.7692C11.7947 16.7672 13.5153 16.0534 14.7843 14.7843C16.0534 13.5153 16.7672 11.7947 16.7692 10Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.12 9.5H6.87C6.59 9.5 6.37 9.72 6.37 10C6.37 10.28 6.59 10.5 6.87 10.5H13.12C13.4 10.5 13.62 10.28 13.62 10C13.62 9.72 13.4 9.5 13.12 9.5Z"
            fill={color}
          />
          <path
            d="M10 2C5.59 2 2 5.59 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2ZM10 17C6.14 17 3 13.86 3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.5 12.75C18.5 12.9489 18.421 13.1397 18.2803 13.2803C18.1397 13.421 17.9489 13.5 17.75 13.5H7.75001C7.55109 13.5 7.36033 13.421 7.21968 13.2803C7.07902 13.1397 7.00001 12.9489 7.00001 12.75C7.00001 12.5511 7.07902 12.3603 7.21968 12.2197C7.36033 12.079 7.55109 12 7.75001 12H17.75C17.9489 12 18.1397 12.079 18.2803 12.2197C18.421 12.3603 18.5 12.5511 18.5 12.75ZM25.5 12.75C25.5 15.2717 24.7522 17.7368 23.3512 19.8335C21.9503 21.9302 19.959 23.5644 17.6292 24.5295C15.2995 25.4945 12.7359 25.747 10.2626 25.255C7.78935 24.7631 5.51751 23.5487 3.73439 21.7656C1.95127 19.9825 0.736955 17.7107 0.244993 15.2374C-0.246968 12.7641 0.00552416 10.2005 0.970541 7.87079C1.93556 5.54103 3.56976 3.54975 5.66648 2.14876C7.76321 0.747774 10.2283 0 12.75 0C16.1303 0.00396981 19.371 1.34854 21.7612 3.73877C24.1515 6.129 25.496 9.36971 25.5 12.75ZM24 12.75C24 10.525 23.3402 8.34989 22.104 6.49984C20.8679 4.64978 19.1109 3.20784 17.0552 2.35636C14.9995 1.50487 12.7375 1.28208 10.5552 1.71617C8.37295 2.15025 6.3684 3.22171 4.79505 4.79505C3.22171 6.36839 2.15025 8.37295 1.71617 10.5552C1.28209 12.7375 1.50488 14.9995 2.35636 17.0552C3.20785 19.1109 4.64979 20.8679 6.49984 22.104C8.34989 23.3402 10.525 24 12.75 24C15.7327 23.9967 18.5922 22.8104 20.7013 20.7013C22.8104 18.5922 23.9967 15.7327 24 12.75Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default MinusCircleIcon;
